import { IAriaLabels } from '@models/IAriaLabels';

const ariaLabels: IAriaLabels = {
  backToFirstLevelNavigationAriaLabel: 'Back to first level of navigation',
  breadcrumbAriaLabel: 'Breadcrumb navigation',
  breadcrumbFooterAriaLabel: 'Breadcrumb footer navigation',
  clearFiltersAriaLabel: 'Clear filters',
  closeAddressListAriaLabel: 'Close address list',
  closeMenuAriaLabel: 'Close menu',
  closeMobileNavigationAriaLabel: 'Close navigation',
  closeModalAriaLabel: 'Close Modal',
  closeSignUpFormAriaLabel: 'Close signup form',
  closeSiteNotificationAriaLabel: 'Close site notification',
  copyToClipboardAriaLabel: 'Copy to clipboard',
  decreaseItemQuantityAriaLabel: 'Decrease item quantity',
  editOrDeleteAriaLabel: 'Edit or delete',
  increaseItemQuantityAriaLabel: 'Increase item quantity',
  mainNavigationAriaLabel: 'Main navigation',
  moreInformationAriaLabel: 'More information',
  muteVideoAriaLabel: 'Mute video',
  nextAriaLabel: 'Go to next slide',
  openAddressListAriaLabel: 'Open address list',
  openImageInFullScreenAriaLabel: 'Open image in full screen',
  openMenuAriaLabel: 'Open menu',
  overlayToCloseDesktopNavigationAriaLabel: 'Close overlay',
  pauseVideoAriaLabel: 'Pause video',
  playVideoAriaLabel: 'Play video',
  previousAriaLabel: 'Go to previous slide',
  removeItemFromCartAriaLabel: 'Remove item from cart',
  searchAriaLabel: 'Search',
  shareToFacebookAriaLabel: 'Share to Facebook',
  shareToWhatsappAriaLabel: 'Share to Whatsapp',
  shareToXAriaLabel: 'Share to X',
  siteNotificationsAriaLabel: 'Site notifications banner',
  unmuteVideoAriaLabel: 'Unmute video',
  uspStripAriaLabel: 'Unique Selling Point Strip',
  zoomInAriaLabel: 'Zoom in',
  zoomOutAriaLabel: 'Zoom out',
};

export default ariaLabels;
